/**
 * BudgetSnapshotBridge — import/export of Engine snapshots for the Editor.
 * Persistence destination (localStorage / API) stays outside this bridge.
 */

import type {
  BudgetCommandResult,
  BudgetEngine,
  BudgetSnapshot,
} from '@/engines/budget'
import { budgetSerializer } from '@/engines/budget'

export class BudgetSnapshotBridge {
  private readonly engine: BudgetEngine

  constructor(engine: BudgetEngine) {
    this.engine = engine
  }

  exportSnapshot(): BudgetSnapshot | null {
    const doc = this.engine.peek()
    if (!doc) return null
    return budgetSerializer.toSnapshot(doc)
  }

  exportJSON(): string {
    return this.engine.exportJSON()
  }

  importJSON(raw: string): BudgetCommandResult {
    return this.engine.importJSON(raw)
  }

  restore(snapshot: BudgetSnapshot): BudgetCommandResult {
    return this.engine.dispatch({
      type: 'RestoreSnapshot',
      snapshot,
    })
  }

  /** Replace engine document from a mapped BudgetDocument (Editor sync). */
  replaceDocument(document: import('@/engines/budget').BudgetDocument): BudgetCommandResult {
    const snapshot = budgetSerializer.toSnapshot(document)
    return this.restore(snapshot)
  }
}
